import api from "./api";
import { toast } from "sonner";

// In-app (blob) download of any API file — uses XHR + blob, the pipeline that works on the
// owner's PC (direct browser downloads get killed by her security software, 2026-09-09).
export async function downloadBlob(path, filename) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
    return true;
  } catch {
    toast.error("Download failed — try again");
    return false;
  }
}

// In-app (blob) save of any generated file — uses XHR + blob, the pipeline that works on the
// owner's PC (direct browser downloads get killed by her security software, 2026-09-09).
export async function saveGeneratedInApp(fname) {
  try {
    const r = await api.get(`/admin/generated/${fname}`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = fname;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
  } catch {
    toast.error("Download failed — try again");
  }
}

// All-staff audit ZIP: too big for one request — the server builds it in the background,
// so we poll until today's file exists, then open it.
export async function downloadAllAuditPackets() {
  const fname = `audit_packets_${new Date().toISOString().slice(0, 10)}.zip`;
  const openFile = () => window.open(`${api.defaults.baseURL}/admin/generated/${fname}`, "_blank");
  try {
    const r = await api.get("/admin/audit-packets.zip", { responseType: "blob", validateStatus: () => true });
    if (r.status === 200) {
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = fname;
      a.click();
      return;
    }
    toast.info("Building all audit packets — this takes a few minutes. It will download when ready.");
    const t0 = Date.now();
    const poll = async () => {
      try {
        await api.get(`/admin/generated/${fname}`, { responseType: "blob" });
        toast.success("Audit packet ZIP is ready");
        openFile();
      } catch {
        if (Date.now() - t0 < 300000) setTimeout(poll, 5000);
        else toast.error("Still building — click again in a minute and it will download.");
      }
    };
    poll();
  } catch (e) {
    toast.error("Could not start the audit packet build");
  }
}
